import 'jquery-zoom';
import { Api } from '../../common/js/api';
import EventsHelper from '../../common/js/eventsHelper';

export default new class Product {
    constructor() {
        this.productPage = document.querySelector('.product');

        if (!this.productPage) return;

        this.conf = {
            textInCart: 'Перейти в корзину',
            countStep: 0.1,
            areaMinValue: 0.1,
            areaMaxValue: 10000,
            itemPrice: $('[data-product-total-price]').data('product-total-price'),
            itemOldPrice: $('[data-product-total-price-old]').data('product-total-price-old')
        };

        this.productId = this.productPage.getAttribute('data-product-id');

        this.btnFavorite = '.product--info-btn-favorite';
        this.btnCart = '.product--info-btn-cart';

        this.totalPrice = '[data-product-total-price]';
        this.totalOldPrice = '[data-product-total-price-old]';

        this.counter = '[data-product-counter]';
        this.btnCounter = '[data-product-counter-btn]';
        this.counterArea = '[data-product-counter-area]';

        this.imgCurrent = '[data-product-img-current]';
        this.imgSlide = '.product--info-img-item';

        this.classAdded = 'fs--added';

        this.eventsHandler();
        this.setTotalPrice();
        this.initImgZoom();
    }

    eventsHandler() {
        let $doc = $(document);

        document.querySelector(this.btnCart).addEventListener('click', this.handleOnCartBtnClick);
        document.querySelector(this.btnFavorite).addEventListener('click', this.handleOnFavoriteBtnClick);


        $doc.on('click', this.btnCounter, (e) => {
            e.preventDefault();
            this.changeCounter($(e.currentTarget));
        });

        $doc.on('click', this.imgSlide, (e) => {
            this.changeCurrentImg($(e.currentTarget))
        });

        $doc.on('input', this.counterArea, (e) => {
            this.checkAreaValue($(e.currentTarget));
            this.setTotalPrice();
        })
    }

    checkAreaValue($area) {
        if ($area.val() > this.conf.areaMaxValue) {
            $area.val(this.conf.areaMaxValue);
        }
    }

    changeCurrentImg($img) {
        let imgHref = $img.attr('src'),
            imgCurrentHref = $(this.imgCurrent).attr('src');

        $(this.imgCurrent).trigger('zoom.destroy');
        $(this.imgCurrent).attr('src', imgHref);
        $img.attr('src', imgCurrentHref);
        this.initImgZoom();
    }

    initImgZoom() {
        $(this.imgCurrent)
            .wrap('<span style="display:inline-block"></span>')
            .css('display', 'block')
            .parent()
            .zoom();
    }

    setTotalPrice() {
        let productCountVal = +$(this.counterArea).val(),
            totalPrice = productCountVal * this.conf.itemPrice,
            totalOldPrice = productCountVal * this.conf.itemOldPrice;

        $(this.totalPrice).text(totalPrice.toFixed(0));
        $(this.totalOldPrice).text(totalOldPrice.toFixed(0));
    }

    changeCounter($btnCounter) {
        let $counterArea = $btnCounter.closest(this.counter).find(this.counterArea),
            counterAreaVal = +$counterArea.val(),
            newVal;

        if ($btnCounter.data('product-counter-btn') === 'plus') {
            newVal = counterAreaVal + this.conf.countStep;
        } else {
            newVal = counterAreaVal - this.conf.countStep;
        }

        if (newVal < this.conf.areaMinValue || newVal > this.conf.maxCount) return;
        $counterArea.val(newVal.toFixed(1));
        this.setTotalPrice();
    }

    handleOnFavoriteBtnClick = e => {
        let btn = e.currentTarget;

        btn.classList.contains(this.classAdded)
            ? this.removeItemFromFavorite()
            : this.addItemToFavorite()

        btn.classList.toggle(this.classAdded)
    }

    handleOnCartBtnClick = e => {
        let btn = e.currentTarget;

        if (btn.classList.contains(this.classAdded)) return;

        e.preventDefault();
        this.addItemToCart(btn);
    }

    addItemToCart(btn) {
        const product_quantity = document.querySelector(this.counterArea).value
        const product_total_price = document.querySelector(this.totalPrice).innerHTML
        const old_price = document.querySelector(this.totalOldPrice) != null ? document.querySelector(this.totalOldPrice).innerHTML : null

        btn.classList.add(this.classAdded);
        btn.innerHTML = this.conf.textInCart;
        EventsHelper.onAddToCart();
        debugger;
        Api.addProductToCart({
            product_id: this.productId,
            product_quantity, product_total_price, old_price
        })
    }

    addItemToFavorite() {
        EventsHelper.onAddToFavorite();
        Api.addProductToFavorite(this.productId);
    }

    removeItemFromFavorite() {
        EventsHelper.onRemoveFromFavorite();
        Api.removeProductFromFavorite(this.productId);
    }
}
